import { Modal, Typography } from "antd"
import { useTranslation } from "react-i18next"
import { useDispatch } from "react-redux"

import AddEnpointForm from "../../../../../Components/Forms/AddEnpointForm"
import Icon from "../../../../../Icon"
import Creators from "../../reducer"

const { Text } = Typography

const AddEndpointModal = ({ modalType, close, eventTypeOptions, onAddEnpointSuccess }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const handleAddEnpoint = (data) => {
    dispatch(Creators.addEndpointRequest({ ...data, onSuccess: onAddEnpointSuccess }))
  }

  return (
    <Modal
      open={modalType?.type === "add_endpoint"}
      onClose={close}
      onCancel={close}
      footer={null}
      centered={true}
      closeIcon={<Icon type="cross_small" />}
      width={400}
      title={t("Add endpoint")}
      destroyOnClose
      className="faq-custom-modal"
      classNames={{ content: "clear-bg" }}
    >
      <Text style={{ display: "block", margin: "10px 0 28px" }}>
        {t("Add an endpoint to start receiving webhook notifications for your selected events.")}
      </Text>

      <AddEnpointForm
        close={close}
        onSubmitAddEnpointForm={handleAddEnpoint}
        eventTypeOptions={eventTypeOptions}
      />
    </Modal>
  )
}

export default AddEndpointModal
